<div class="onboarding" *ngIf="(me$ | async) as me">
  <app-onboarding-personal-info [user]="me" [completed]="completed"></app-onboarding-personal-info>
  <app-onboarding-checklist *ngIf="!completed" [options]="checklistOptions"></app-onboarding-checklist>
</div>
